import * as React from 'react'
import { colors, P18 } from '@components/shared'
import { Col, Hidden, Row, config } from 'react-awesome-styled-grid'
import Categories from '@components/blog/Categories'
import type { BlogCategoryType } from '../../services/contentfulPosts'
import styled from 'styled-components'
import type { FontPropsType, TextAlignType } from '@components/shared'

type PropsType = {
  categories: BlogCategoryType[],
  title: string,
  subtitle: string
}
export default function BlogHeader (props: PropsType): React.ReactNode {
  return (
    <>
      <Row>
        <Col xs={4} sm={8} lg={10} offset={{
          lg: 1,
          xl: 1
        }} align={'center'}>
          <TitleContainer>
            <H160 textAlign={'center'} color={colors.sand}>{props.title}</H160>
          </TitleContainer>
          <SubTitleContainer>
            <P18
              textAlign='center'
              color={colors.sand}
            >
              {props.subtitle}
            </P18>
          </SubTitleContainer>
          <Categories categories={props.categories}/>
          <Hidden xs={true}>
            <Hr size={1}/>
          </Hidden>
        </Col>
      </Row>
    </>
  )
}

const Hr = styled.hr<any>`
  height: 1px;
  background-color:${colors.sand};
  border: none;
  width: 100%;
  margin-top: 25px;
  margin-bottom: 50px;
`

const TitleContainer = styled.div<any>`
  margin-top: 50px;
  margin-bottom: 15px;
  
  ${(props: any): any => config(props).media.lg`
    margin-top: 90px;
    margin-bottom: 20px;
  `}
  ${(props: any): any => config(props).media.xl`
    margin-top: 100px;
    margin-bottom: 20px;
  `}

`
const SubTitleContainer = styled.div<any>`
   width: 335px;
  ${(props: any): any => config(props).media.sm`
    margin-bottom: 46px;
    width: 500px;
  `}
  ${(props: any): any => config(props).media.xl`
    margin-bottom: 56px;
    width: 600px;
  `}
  ${(props: any): any => config(props).media.lg`
    margin-bottom: 46px;
    width: 600px;
  `}
`
export const H160 = styled.h1<any>`
  color: ${(props: FontPropsType): string => props.color || colors.white};
  font-family: 'Queens Condensed Light';
  font-style: normal;
  font-weight: ${(props: FontPropsType): number => props.fontWeight || 300};
  letter-spacing: ${(props: FontPropsType): number => props.letterSpacing || 0};
  text-align: ${(props: FontPropsType): TextAlignType => props.textAlign || 'left'};
  margin: 0;
  font-size: 45px;
  line-height: 49px;

  ${(props: any): any => config(props).media.lg`
    font-size: 60px;
    line-height: 66px;
  `}
  ${(props: FontPropsType): string | null | undefined => props.styles}
`
